import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Typography } from "@digital-services/ui";

import { CreateOrganizationButton } from "@organization/components/CreateOrganizationButton";

import { useUserContext } from "@hooks/useUserContext";

export const QuickActionsPanel: FunctionComponent = () => {
  const { user } = useUserContext();

  const { t } = useTranslation(undefined, {
    keyPrefix: "dashboard.quick-actions"
  });

  return (
    <div className="flex flex-col" data-testid="quick-actions-panel">
      <Typography variant="sectionTitle">{t("section_title")}</Typography>
      <div className="flex flex-col gap-10">
        {user.isSuperAdmin ? (
          <CreateOrganizationButton />
        ) : (
          <Typography variant="description">N/A</Typography>
        )}
      </div>
    </div>
  );
};
